export class PageMetadata {
    size: number = 10;
    totalElements: number = 0;
    totalPages: number = 0;
    number: number = 0;
}